import React, { useContext } from 'react';
import styles from './FONASUCustomerReview.css';
import { formatSsnForDisplay, provideDefault } from '../../flows/shared/utils';
import { FlowContext } from '../../core/flow-engine';

const RenderContactInfo = ({ emailAddress, phone1, phone2, phone3 }) => {
  return (
    <>
      <div className="qv-row contact-fields">
        <div className="qv-col">
          <div className="field-label">Email Address</div>
          <div className="field-value">{emailAddress}</div>
        </div>
        <div className="qv-col">
          <div className="field-label">Mobile Phone Number</div>
          <div className="field-value">{phone1}</div>
        </div>
      </div>
      {(phone2 || phone3) && (
        <div className="qv-row contact-fields">
          {phone2 && (
            <div className="qv-col">
              <div className="field-label">Daytime Phone Number</div>
              <div className="field-value">{phone2}</div>
            </div>
          )}
          {phone3 && (
            <div className="qv-col">
              <div className="field-label">Evening Phone Number</div>
              <div className="field-value">{phone3}</div>
            </div>
          )}
        </div>
      )}
      <style jsx>{styles}</style>
    </>
  );
};
const FONASUCustomerReview = ({
  customer,
  mailingAddressDifferent,
  phone1,
  phone2,
  phone3
}) => {
  const { formProps } = useContext(FlowContext);

  const {
    name: { firstName, middleName, lastName },
    residentialAddress: { street1, street2, zip, city, state } = {},
    mailingAddress: {
      street1: mailingStreet1,
      street2: mailingStreet2,
      city: mailingCity,
      state: mailingState,
      zip: mailingZip
    } = {},
    primaryEmailAddress: emailAddress,
    citizenship,
    taxID,
    dob
  } = customer;

  const citizenshipStatus =
    {
      US_CITIZEN: 'U.S. Citizen',
      RESIDENT_ALIEN: 'U.S. Resident Alien'
    }[citizenship] || citizenship;

  return (
    <div className="review-section">
      <div className="residential-address-wrapper">
        <div className="qv-row">
          <div className="qv-col">
            <div className="field-label">First Name</div>
            <div className="field-value">{firstName}</div>
          </div>
          <div className="qv-col">
            <div className="field-label">Middle Name</div>
            <div className="field-value">{middleName}</div>
          </div>
          <div className="qv-col">
            <div className="field-label">Last Name</div>
            <div className="field-value">{lastName}</div>
          </div>
        </div>
        <div className="qv-row">
          <div className="qv-col">
            <div className="field-label">Date of Birth</div>
            <div className="field-value">{dob}</div>
          </div>
          <div className="qv-col">
            <div className="field-label">Social Security Number</div>
            <div className="field-value ssn">{formatSsnForDisplay(taxID)}</div>
          </div>
          <div className="qv-col">
            <div className="field-label">Citizenship</div>
            <div className="field-value">{citizenshipStatus}</div>
          </div>
        </div>
        <div className="qv-row">
          <div className="qv-col">
            <div className="field-label">Address Line 1</div>
            <div className="field-value">
              {provideDefault(street1, formProps.residentialStreet1)}
            </div>
          </div>
          <div className="qv-col">
            <div className="field-label">Address Line 2</div>
            <div className="field-value">
              {provideDefault(street2, formProps.residentialStreet2)}
            </div>
          </div>
        </div>
        <div className="qv-row">
          <div className="qv-col">
            <div className="field-label">City</div>
            <div className="field-value">
              {provideDefault(city, formProps.residentialCity)}
            </div>
          </div>
          <div className="qv-col">
            <div className="field-label">Zip Code</div>
            <div className="field-value">
              {provideDefault(zip, formProps.residentialZip)}
            </div>
          </div>
          <div className="qv-col">
            <div className="field-label">State</div>
            <div className="field-value">
              {provideDefault(state, formProps.residentialState)}
            </div>
          </div>
        </div>
      </div>

      {mailingAddressDifferent && (
        <div className="mailing-address-wrapper">
          <div className="qv-row">
            <div className="qv-col">
              <div className="field-label">Mailing Address</div>
              <div className="field-value">
                {provideDefault(mailingStreet1, formProps.mailingStreet1)}
              </div>
            </div>
            <div className="qv-col">
              <div className="field-label">Address Line 2</div>
              <div className="field-value">
                {provideDefault(mailingStreet2, formProps.mailingStreet2)}
              </div>
            </div>
          </div>
          <div className="qv-row">
            <div className="qv-col">
              <div className="field-label">City</div>
              <div className="field-value">
                {provideDefault(mailingCity, formProps.mailingCity)}
              </div>
            </div>
            <div className="qv-col">
              <div className="field-label">Zip Code</div>
              <div className="field-value">
                {provideDefault(mailingZip, formProps.mailingZip)}
              </div>
            </div>
            <div className="qv-col">
              <div className="field-label">State</div>
              <div className="field-value">
                {provideDefault(mailingState, formProps.mailingState)}
              </div>
            </div>
          </div>
        </div>
      )}
      <RenderContactInfo
        emailAddress={emailAddress}
        phone1={phone1}
        phone2={phone2}
        phone3={phone3}
      />
      <style jsx>{styles}</style>
    </div>
  );
};

export default FONASUCustomerReview;
